import bairro from './bairro'
import cidadao from './cidadao'
import convenioMedico from './convenio-medico'
import convenioOdontologico from './convenio-odontologico'
import logradouro from './logradouro'
import loteamento from './loteamento'
import planoFunerario from './plano-funerario'
import usuario from './usuario'
import usuarioOrigem from './usuario-origem'

export default [
    {
        meta: {authenticated: true, layout: 'admin'},
        path: '/cadastro',
        component: () => import('@/views/cadastro/Index'),
        children: [
            ...bairro,
            ...cidadao,
            ...convenioMedico,
            ...convenioOdontologico,
            ...logradouro,
            ...loteamento,
            ...planoFunerario,
            ...usuario,
            ...usuarioOrigem,
        ],
    },
]